import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CollectionsService {
  readonly rootURL = environment.ImpataAppAPIRoot;

  constructor(private http: HttpClient) { }


  getSortPerPageCollections(search: string, sortBy: string, isAscending: boolean, offset: number,
     perPage: number, toDate, fromDate, moduleId: number, batchId: number) {
    return this.http.get(this.rootURL + `Collections/getSchoolCollections?searchString=${search}` +
      `&sortBy=${sortBy}&isAsc=${isAscending}&offSet=${offset}&perPage=${perPage}&fromDate=${fromDate}&toDate=${toDate}&moduleId=${moduleId}&batchId=${batchId}`);
  }
}
